import { NotificationTypeIdType } from '@/enums/notificationTypeId';
import { Notification } from '@/models/notification/notification';

export function isNotificationOfType<T extends Notification>(
  notification: Notification,
  typeId: NotificationTypeIdType,
): notification is T {
  return notification.type?.id?.toString() === typeId?.toString();
}
